import { CableChain, DynamicCableChainExtraProps } from '../CableChain';
import {
  DynamicModel,
  WithDimensionsReceivedProps,
  WithDimensionsSentProps,
  BasicDynamicModelEditor,
} from '@k3/core';
import {
  DefaultModelProps,
  Model,
} from '@k3/core/dist/src/lib/types/model.interface';
import { Stack } from '@mui/material';
import { ModelSelector } from './ModelSelector';
import { useMemo } from 'react';

type DynamicCableChainProps = WithDimensionsReceivedProps &
  DefaultModelProps &
  DynamicCableChainExtraProps &
  Pick<Model, 'id'>;

const DynamicCableChain = (props: DynamicCableChainProps) => {
  const userData = useMemo(
    () => ({
      modelId: props.id,
    }),
    [props.id]
  );

  return (
    <group userData={userData}>
      <CableChain {...props} />
    </group>
  );
};

export const cableChain: DynamicModel<
  DynamicCableChainProps,
  WithDimensionsSentProps & DynamicCableChainExtraProps
> = {
  type: 'cableChain',
  label: 'Kabelkette',
  disabledForAR: false,
  component: (props) => {
    return <DynamicCableChain {...props} />;
  },
  propsDialog: (props) => {
    return (
      <Stack
        direction="column"
        spacing={4}
        sx={{
          width: '100%',
          maxWidth: 450,
          overflowX: 'hidden',
        }}
      >
        <BasicDynamicModelEditor {...props} materialsAreEditable={false} />

        <ModelSelector
          label={'Startteil'}
          modelKey={props.dynamicModelProps.startCapKey}
          onChange={props.onChange('startCapKey')}
        />
        <ModelSelector
          label={'Mittelteil'}
          modelKey={props.dynamicModelProps.middleCapKey}
          onChange={props.onChange('middleCapKey')}
        />
        <ModelSelector
          label={'Endteil'}
          modelKey={props.dynamicModelProps.endCapKey}
          onChange={props.onChange('endCapKey')}
        />
      </Stack>
    );
  },
  defaultProps: {
    width: { expression: '1' },
    height: { expression: '1' },
    depth: { expression: '1' },
    startCapKey: undefined,
    middleCapKey: undefined,
    endCapKey: undefined,
  },
  materials: [],
};
